import CollectionPage from 'state/selectors/collection-page';

const trackCollectionPageSetFilter = (action, prevState, nextState) => {
  const { filterIdentifier, option, value } = action.payload;

  if (!value) {
    return undefined;
  }

  const collectionHandle = CollectionPage.getCollectionHandle(nextState);

  return {
    hitType: 'event',
    eventCategory: 'collections',
    eventAction: `filterBy - ${filterIdentifier} - ${option}`,
    eventLabel: collectionHandle,
  };
};

const trackCollectionPageClearFilters = (action, prevState, nextState) => {
  const collectionHandle = CollectionPage.getCollectionHandle(nextState);

  return {
    hitType: 'event',
    eventCategory: 'collections',
    eventAction: `clearFilters`,
    eventLabel: collectionHandle,
  };
};

const trackCollectionPageOpenFilterDrawer = (action, prevState, nextState) => {
  const collectionHandle = CollectionPage.getCollectionHandle(nextState);

  return {
    hitType: 'event',
    eventCategory: 'collections',
    eventAction: `openFilterDrawer`,
    eventLabel: collectionHandle,
  };
};

export {
  trackCollectionPageSetFilter,
  trackCollectionPageClearFilters,
  trackCollectionPageOpenFilterDrawer,
};
